import { MdOutlineHelpOutline } from "react-icons/md";

type OnboardingReplayButtonProps = {
    onReplay: () => void;
};

export default function OnboardingReplayButton({ onReplay }: OnboardingReplayButtonProps) {
    return (
        <button
            onClick={onReplay}
            title="Repetir tour de introdução"
            aria-label="Repetir onboarding"
            className="group flex h-8 w-8 items-center justify-center rounded-lg border border-white/10 bg-white/5 text-gray-400 transition-all hover:border-cyan-500/40 hover:bg-cyan-500/10 hover:text-cyan-400 hover:shadow-lg hover:shadow-cyan-500/10"
        >
            <MdOutlineHelpOutline className="h-4 w-4 transition-transform group-hover:scale-110" />
        </button>
    );
}
